import CONSTANTS from '../../constants';
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader';

const { GCPCERTS_API_URL } = CONSTANTS;

const getSingleGcpCert = async (gcpCertID: string) => {
  const response = await fetchWithAuthorizationHeader(
    `${GCPCERTS_API_URL}?gcpCertID=${gcpCertID}`
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch certificate ${gcpCertID}`);
  }

  return response.json();
};

export default getSingleGcpCert;